import { apiAxios } from '@/api/apiConfig';

// ── 템플릿 관리 ──────────────────────────────────────────────

export interface MarketingEmailTemplate {
  id: number;
  name: string;
  subject: string;
  body: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MarketingEmailTemplateRequest {
  name: string;
  subject: string;
  body: string;
}

export const marketingTemplateApi = {
  list: () => apiAxios.get<MarketingEmailTemplate[]>('/admin/marketing/templates'),

  create: (data: MarketingEmailTemplateRequest) =>
    apiAxios.post<MarketingEmailTemplate>('/admin/marketing/templates', data),

  update: (id: number, data: MarketingEmailTemplateRequest) =>
    apiAxios.put<MarketingEmailTemplate>(`/admin/marketing/templates/${id}`, data),

  activate: (id: number) =>
    apiAxios.post<MarketingEmailTemplate>(`/admin/marketing/templates/${id}/activate`),
};

// ── 발송 현황 ────────────────────────────────────────────────

export type MarketingSendResult = 'SUCCESS' | 'FAILED';

export interface MarketingEmailSendLog {
  id: number;
  targetSiteId: number;
  templateId: number | null;
  companyNameSnapshot: string;
  categorySnapshot: string | null;
  toEmail: string;
  subjectSnapshot: string;
  aiReason: string | null;
  result: MarketingSendResult;
  failReason: string | null;
  sentAt: string;
}

export interface MarketingEmailSendLogPage {
  content: MarketingEmailSendLog[];
  totalElements: number;
  totalPages: number;
  number: number; // 현재 페이지(0-base)
  size: number;
}

export interface MarketingSendLogSearchParams {
  startDate?: string; // ISO 8601, 예: 2026-09-01T00:00:00
  endDate?: string;
  category?: string;
  companyName?: string;
  email?: string;
  result?: MarketingSendResult;
  page?: number;
  size?: number;
}

export const marketingSendLogApi = {
  search: (params: MarketingSendLogSearchParams) =>
    apiAxios.get<MarketingEmailSendLogPage>('/admin/marketing/send-logs', { params }),
};

// ── 후보 사이트 수동 등록 (무상 경로, 2026-09-14 신설) ────────────
// Anthropic 유료 웹검색 대신 관리자가 후보 홈페이지 URL을 직접 붙여넣으면
// 서버가 Jsoup으로 접속해 회사명(페이지 제목)/이메일(footer)만 추출해 등록한다.

export type MarketingManualCandidateStatus = 'PENDING' | 'EXCLUDED' | 'DUPLICATE' | 'ERROR';

export interface MarketingManualCandidateResult {
  url: string;
  companyName: string | null;
  status: MarketingManualCandidateStatus;
  message: string;
}

export interface MarketingManualCandidateRequest {
  urls: string[];
  category: string;
}

export const marketingTargetSiteApi = {
  manualAdd: (data: MarketingManualCandidateRequest) =>
    apiAxios.post<MarketingManualCandidateResult[]>('/admin/marketing/target-sites/manual-add', data),
};
